var path = 'dashboard/dashboard-card.tpl.html';
var html = " <div class=\"tb-small tb-dashboard-assigned-customers\" ng-show=\"vm.parentCtl.dashboardsScope === 'tenant' && vm.item.assignedCustomersText\">{{'dashboard.assignedToCustomers' | translate}}: '{{vm.item.assignedCustomersText}}'</div> <div class=tb-small ng-show=\"vm.parentCtl.dashboardsScope === 'tenant' && vm.item.publicCustomerId\">{{'dashboard.public' | translate}}</div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard-card.tpl.html
// module id = 1419
// module chunks = 1